import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
export interface DialogData {
  vehicle_no: any;
  type: any;
  ownerName: any;
  policyNumber: any;
  roadTaxDate: any;
  insuranceDueDate: any;
  fitnessDueDate: any;
}

@Component({
  selector: "app-total-vehicle",
  templateUrl: "./total-vehicle.component.html",
  styleUrls: ["./total-vehicle.component.css"],
})
export class TotalVehicleComponent implements OnInit {
  @Input() childData: string;
  @ViewChild("paginator") paginator: MatPaginator;
  isButtonDisabled: boolean = true;
  pageName: any;

  users: any = [];
  innerWidth: number;
  heading: any;

  vehicles: any = {
    totalVehicles: 0,
    documentsExpired: 0,
  };
  userSessionData: any;
  isAdmin: boolean = false;
  loginbtn: any;
  dataNew: any;
  expiredDocs: any = [];
  dataSource: MatTableDataSource<any>;
  displayedColumns: any = [
    "vehicle_no",
    "type",
    "ownerName",
    "policyNumber",
    "roadTaxDate",
    "insuranceDueDate",
    "fitnessDueDate",
    "action",
  ];
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private router: Router,
    private superAdminService: SuperAdminService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.userSessionData = JSON.parse(sessionStorage.getItem("userSession"));
    if (this.userSessionData?.user_role_id?.[0] === 1) {
      this.isAdmin = true;
    }
    this.route.params.subscribe((params) => {
      this.pageName = params["param3"];

      // console.log("data  vehicles from route parameters", this.pageName)
    });

    // this.representation(this.pageName);
    this.dataNew = this.data.data;
    this.heading = this.data.heading;
    this.getExpiredVehicles();
  }

  getExpiredVehicles() {
    this.spinner.show();

    this.superAdminService.getExpiredVehicles().subscribe({
      next: (res) => {
        if (res.status) {
          this.expiredDocs = res.data || [];

          this.dataSource = new MatTableDataSource(this.expiredDocs);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          this.vehicles.documentsExpired = this.expiredDocs.length;
        } else {
          this.toastr.error(res.message);
        }
      },
      error: () => {
        this.toastr.error("Failed to load expired vehicles");
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }

  filterData(value) {
    this.dataSource.filter = value;
  }

  sortData(sort: Sort) {
    const data = this.dataSource.filteredData;
    if (!sort.active || sort.direction === "") {
      return this.dataSource;
    }
    this.dataSource.filteredData = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "consignee_name":
          return compare(
            lower(a.consignee_name),
            lower(b.consignee_name),
            isAsc
          );
        case "consignor_name":
          return compare(
            lower(a.consignor_name),
            lower(b.consignor_name),
            isAsc
          );
        case "clientName":
          return compare(lower(a.clientName), lower(b.clientName), isAsc);
        case "date":
          return compare(a.date, b.date, isAsc);
        case "from":
          return compare(lower(a.from), lower(b.from), isAsc);
        case "to":
          return compare(lower(a.to), lower(b.to), isAsc);
        default:
          return 0;
      }
    });
    function compare(a: number | string, b: number | string, isAsc: boolean) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    function lower(value) {
      return value ? value.toLowerCase() : value;
    }
  }
  backTo() {
    window.history.back();
  }
}
